import * as React from 'react'

const AddBtnIcon = (props: { className?: string; onClick?: (e: any) => void }) => {
  return (
    <svg
      onClick={props.onClick}
      className={'icon ' + props.className}
      width='84'
      height='84'
      viewBox='0 0 84 84'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_d)'>
        <circle cx='32' cy='32' r='32' transform='translate(10 10)' fill='white' />
      </g>
      <circle cx='32' cy='32' r='32' transform='translate(10 10)' fill='#37C47E' fillOpacity='0.3' />
      <circle cx='26.6667' cy='26.6667' r='26.6667' transform='translate(15.3335 15.333)' fill='#37C47E' />
      <line
        y1='-1'
        x2='18.6667'
        y2='-1'
        transform='translate(40.6665 31.333) rotate(90)'
        stroke='white'
        strokeWidth='2'
      />
      <line y1='-1' x2='18.6667' y2='-1' transform='translate(32.6665 42)' stroke='white' strokeWidth='2' />
      <defs>
        <filter
          id='filter0_d'
          x='0'
          y='0'
          width='84'
          height='84'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 255 0' />
          <feOffset />
          <feGaussianBlur stdDeviation='5' />
          <feColorMatrix type='matrix' values='0 0 0 0 0.215686 0 0 0 0 0.768627 0 0 0 0 0.494118 0 0 0 0.3 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow' result='shape' />
        </filter>
      </defs>
    </svg>
  )
}

export default AddBtnIcon



// WEBPACK FOOTER //
// ./src/components/icons/ui/AddBtn.tsx